import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import './index.styl'

const StockPrice = ({ pageData, activeCat }) => {
  const { t } =  useTranslation()
  return (
    <div className="stock-price investor__main">
    	<h2 className="investor__title">{t(`nav_${activeCat}`)}</h2>
    	<ul>
    		{
    			pageData.map(data => (
    				<li key={data.id}  className="stock-price__list-item">
    					<a href={data.link} target="_blank">{data.title}</a>
    				</li>
    			))
    		}
    	</ul>
    </div>
  )
}

StockPrice.propTypes = {}

export default StockPrice
